module.exports = __webpack_public_path__ + "static/media/glogos.a5766ceb.png";